<template>
    <div class="invoice-main-data-view detail-card">
        <el-form ref="form" :rules="rules" :model="simpleInfo">
            <div class="title-block">
                <div class="title">
                    <div class="edit-form">
                        <div>{{ form.description }}</div>
                    </div>
                </div>
            </div>
            <el-row :gutter="40" style="margin-bottom: 15px">
                <el-col :sm="14">
                    <spec-view>
                        <spec-item label="申請人">
                            {{ form.crT_NAM }}
                        </spec-item>
                        <spec-item label="申請時間">
                            {{ form.crT_DAT | dateFormater("YYYY-MM-dd") }}
                        </spec-item>
                    </spec-view>
                </el-col>
                <el-col :sm="10"> </el-col>
            </el-row>
        </el-form>
        <!-- 核銷項目 -->
        <ReimbursementTable :reimbursement-list="form.refenceInvoces" :disable-invoice-dialog="disableInvoiceDialog" @openInvoice="openInvoiceDetail" />
        <!-- 發票項目 -->
        <InvoiceItemView ref="InvoiceItemView" style="margin-top: 30px" :invoiceItems="form.items" />
        <div class="amt-summary">
            <spec-view style="">
                <spec-item label="未稅總計">
                    <Money :v="form.amt - form.amT_TAX" />
                    <span style="margin-left: 10px">{{ form.cny }}</span>
                </spec-item>
                <spec-item label="應稅">
                    <Money :v="form.amT_TAX" />
                    <span style="margin-left: 10px">{{ form.cny }}</span>
                </spec-item>
                <spec-item v-if="!form.foO_DIS_CNL && form.foO_DIS_AMT" label="折讓退回">
                    <Money :v="form.foO_DIS_AMT" />
                    <span style="margin-left: 10px">{{ form.cny }}</span>
                </spec-item>
                <spec-item label="含稅總計">
                    <Money :v="form.amt" style="font-size: 20pt" />
                    <span style="margin-left: 10px">{{ form.cny }}</span>
                </spec-item>
            </spec-view>
        </div>
        <InvoiceDetailDialog v-if="!disableInvoiceDialog" disable-reimbursement-dialog :visible="invoiceDetailDialog.visible" :sno="invoiceDetailDialog.sno" @close="handleInvoiceDetailDialogClose" />
    </div>
</template>

<script>
import SpecView from '@/components/ui/SpecView/SpecView.vue';
import SpecItem from '@/components/ui/SpecView/SpecItem.vue';
import InvoiceItemView from '@/components/dashboard/Invoice/InvoiceDetailDialog/InvoiceItemView.vue';
import ReimbursementTable from '@/components/dashboard/Finance/ReimbursementInvoice/ReimbursementTable.vue';

export default {
    props: {
        invoiceItems: {
            type: Array,
            default: () => [],
        },
        form: {
            type: Object,
            default: () => {},
        },
        disableInvoiceDialog: Boolean,
    },
    components: {
        SpecView,
        SpecItem,
        InvoiceItemView,
        ReimbursementTable,
        InvoiceDetailDialog: () => import('@/components/dashboard/Invoice/InvoiceDetailDialog.vue'),
    },
    computed: {
        calculateNetAmount() {
            if (this.form.tax === 3) return this.form.amt;
            return this.form.invoiceItems ? this.form.invoiceItems.reduce((sum, invoice) => sum + invoice.amt, 0) : 0;
        },
        isStateItemInlineEditorShow() {
            return this.form.incomeItemNo && this.form.status !== 0 && this.form.status !== 1 && this.form.status !== 4;
        },
    },
    data() {
        return {
            isEditMode: false,
            isLoading: false,

            simpleInfo: {
                description: null,
                pdat: null,
                mem: null,
            },
            rules: {
                description: [{ required: true, message: '請輸入摘要', trigger: 'blur' }],
                pdat: [{ required: true, message: '請輸入預計收款日', trigger: 'change' }],
            },

            invoiceDetailDialog: {
                visible: false,
                sno: null,
            },
        };
    },
    watch: {
        form() {
            this.onInit();
        },
    },
    methods: {
        onInit() {
            this.isEditMode = false;
            this.simpleInfo = {
                description: this.form.description,
                pdat: this.form.pdat,
                mem: this.form.mem,
            };
        },
        openInvoiceDetail(sno) {
            if (this.disableInvoiceDialog) return;
            this.invoiceDetailDialog.sno = sno;
            this.invoiceDetailDialog.visible = true;
        },
        handleInvoiceDetailDialogClose() {
            this.invoiceDetailDialog.visible = false;
            this.invoiceDetailDialog.sno = null;
        },
    },
};
</script>

<style lang="scss" scoped>
.invoice-main-data-view {
    .title-block {
        margin: 15px 0 20px 0;
        display: flex;
        align-items: center;
        .title {
            font-size: 15pt;
            font-weight: bold;
            margin-top: 3px;
            flex: 1;
        }
    }
    .edit-form {
        flex: 1;
        display: flex;
        align-items: center;
        > *:nth-child(1) {
            flex: 1;
            // margin-right: 10px;
        }
        > *:nth-child(2) {
            width: 100px;
            display: flex;
            justify-content: flex-end;
        }
    }
}
</style>

<style lang="scss">
.invoice-main-data-view .spec-view .spec-item .value {
    vertical-align: top;
}
</style>
